import { CheckCheck, Trash2 } from "lucide-react";
import { Empty } from "./AdminStats";

const formatDate = (iso) => new Date(iso).toLocaleString("es-CO");

const MessageCard = ({ msg, onMarkRead, onDelete }) => (
    <div
        className={`rounded-2xl bg-white border ${msg.leido ? "border-black/5" : "border-brand-green/40"} p-6`}
        data-testid={`admin-message-${msg.id}`}
    >
        <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
                <div className="flex items-center gap-2">
                    <h3 className="font-display font-semibold text-brand-navy text-lg">{msg.nombre}</h3>
                    {!msg.leido && (
                        <span className="px-2 py-0.5 rounded-full bg-brand-green text-white text-[10px] font-bold uppercase tracking-wider">
                            Nuevo
                        </span>
                    )}
                </div>
                <div className="text-sm text-muted-foreground mt-1">
                    {msg.email}
                    {msg.telefono && ` · ${msg.telefono}`}
                </div>
                <div className="text-xs text-muted-foreground mt-1">{formatDate(msg.created_at)}</div>
            </div>
            <div className="flex gap-2">
                {!msg.leido && (
                    <button
                        type="button"
                        onClick={() => onMarkRead(msg.id)}
                        className="h-9 w-9 rounded-full bg-brand-green-light text-brand-green hover:bg-brand-green hover:text-white transition-colors flex items-center justify-center"
                        title="Marcar como leído"
                        data-testid={`admin-mark-read-${msg.id}`}
                    >
                        <CheckCheck size={16} />
                    </button>
                )}
                <button
                    type="button"
                    onClick={() => onDelete(msg.id)}
                    className="h-9 w-9 rounded-full bg-red-50 text-red-600 hover:bg-red-600 hover:text-white transition-colors flex items-center justify-center"
                    title="Eliminar"
                    data-testid={`admin-delete-msg-${msg.id}`}
                >
                    <Trash2 size={16} />
                </button>
            </div>
        </div>
        <div className="mt-4 pt-4 border-t border-black/5">
            <div className="text-xs uppercase tracking-wider font-bold text-brand-green mb-2">Asunto</div>
            <div className="font-medium text-brand-navy">{msg.asunto}</div>
            <div className="text-xs uppercase tracking-wider font-bold text-brand-green mt-3 mb-2">Mensaje</div>
            <div className="text-sm text-muted-foreground whitespace-pre-wrap leading-relaxed">{msg.mensaje}</div>
        </div>
    </div>
);

export const MessagesTab = ({ messages, onMarkRead, onDelete }) => (
    <div className="space-y-3" data-testid="admin-messages-list">
        {messages.length === 0 && <Empty text="No hay mensajes aún." />}
        {messages.map((m) => (
            <MessageCard key={m.id} msg={m} onMarkRead={onMarkRead} onDelete={onDelete} />
        ))}
    </div>
);
